import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import MultiRangeFilter from '../../../../../molecules/formMultiRange';
import { useYearsOfExperienceFilter } from './useYearsOfExperienceFilter';

export const YearsOfExperienceFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit } = useYearsOfExperienceFilter({
    setFilters,
  });

  const initialValue = value
    ? {
        min: value.years_experience_gteq || 0,
        max: value.years_experience_lteq || 41,
      }
    : null;

  return (
    <Formik
      initialValues={{ yearsOfExperience: initialValue }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field name="yearsOfExperience" title="Years of experience" min={0} max={41} component={MultiRangeFilter} />
      </Form>
    </Formik>
  );
};

YearsOfExperienceFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

YearsOfExperienceFilter.defaultProps = {
  value: null,
};
